import React, { useState } from 'react';

const panelStyle = {
  width: 280,
  background: '#16213e',
  borderLeft: '1px solid #333',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
};

const applyBtnStyle = {
  padding: '8px 16px',
  background: '#0f3460',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
  width: '100%',
  marginTop: 12,
};

const inputStyle = {
  width: 60,
  padding: '4px 6px',
  background: '#1a1a2e',
  color: '#eee',
  border: '1px solid #444',
  borderRadius: 4,
  fontSize: 12,
  textAlign: 'center',
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 6,
};

const labelStyle = {
  fontSize: 11,
  color: '#999',
  width: 60,
};

/**
 * BlemishPanel provides inputs for specifying a blemish location and radius.
 *
 * @param {{ editor: object }} props
 */
export default function BlemishPanel({ editor }) {
  const [centerX, setCenterX] = useState(0);
  const [centerY, setCenterY] = useState(0);
  const [radius, setRadius] = useState(15);

  const handleApply = () => {
    editor.blemishRemove({
      center_x: Number(centerX),
      center_y: Number(centerY),
      radius: Number(radius),
    });
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 8px', fontSize: 14 }}>Blemish Removal</h3>
      <p style={{ fontSize: 11, color: '#888', margin: '0 0 12px' }}>
        Specify the blemish center and brush radius.
      </p>

      <div style={rowStyle}>
        <span style={labelStyle}>Center X</span>
        <input
          type="number"
          value={centerX}
          onChange={(e) => setCenterX(e.target.value)}
          style={inputStyle}
        />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Center Y</span>
        <input
          type="number"
          value={centerY}
          onChange={(e) => setCenterY(e.target.value)}
          style={inputStyle}
        />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Radius</span>
        <input
          type="number"
          min={1}
          max={200}
          value={radius}
          onChange={(e) => setRadius(e.target.value)}
          style={inputStyle}
        />
      </div>

      <button style={applyBtnStyle} onClick={handleApply}>
        Remove Blemish
      </button>
    </div>
  );
}
